export function formatApiError(error) {
  try {
    if (error.response && error.response.data) {
      const data = error.response.data;
      if (data.defaultUserMessage) {
        return data.defaultUserMessage;
      }
      if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
        return data.errors[0].defaultUserMessage || JSON.stringify(data.errors[0]);
      }
      if (typeof data === "string") {
        return data;
      }
      return JSON.stringify(data);
    }

    if (error.message && typeof error.message === "object") {
      const msg = error.message;
      if (msg.defaultUserMessage) {
        return msg.defaultUserMessage;
      }
      if (msg.errors && Array.isArray(msg.errors) && msg.errors.length > 0) {
        return msg.errors[0].defaultUserMessage || JSON.stringify(msg.errors[0]);
      }
      if (msg.developerMessage) {
        return msg.developerMessage;
      }
      return JSON.stringify(msg);
    }

    if (typeof error.message === "string") {
      return error.message;
    }
    return "Something went wrong!";
  } catch (e) {
    return "Unexpected error format.";
  }
}
